import React, { useState, useCallback } from 'react';
import { Form, Button, Alert, Divider, message } from 'antd';
import { Project } from '../project_settings/forms/general/types';
import styles from './index.module.css';
import * as translations from './strings';
import { getLangKey } from '../../models/Language';
import { onContactSupport } from 'appJS/utils/HelpArticleButton';
import { AIBetaOptIn } from './AIBetaOptIn';
import useProjectMutation from '../project_settings/forms/general/hooks/useProjectMutation';
import { AISettingsForm, handleEnableOrDisableBeta } from './AISettingsForm';
import { AIBanner } from './AIBanner';

const strings = translations[getLangKey()];

type Props = {
  project: Project;
  container: HTMLDivElement;
  refetch: () => void;
};

export const AISettings = ({ project, container, refetch }: Props) => {
  const [, updateState] = useState<{}>();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [form] = Form.useForm();

  const [submit, { updateProjectLoading }] = useProjectMutation({
    project,
    message,
    refetch,
    ...form
  });

  const inAiBeta = !!project.experiments?.includes('ai_features');

  return (
    <div className={styles.aiSettingsContainer}>
      <AIBanner inAiBeta={inAiBeta} />
      {inAiBeta ? (
        <>
          <AISettingsForm
            form={form}
            submit={submit}
            forceUpdate={forceUpdate}
            project={project}
            loading={updateProjectLoading}
            onOptInOrOut={(optIn: boolean) => refetch()}
            container={container}
            duplicateTasksExperiment={true}
          />
          <Divider className={styles.divider} />
          <Alert
            message={
              <div className={styles.alertMessageContainer}>
                <span className={styles.alertMessage}>{strings.improveAI}</span>
                <Button size="small" type="link" onClick={onContactSupport}>
                  {strings.suggestImprovements}
                </Button>
              </div>
            }
            type="info"
            showIcon
          />
        </>
      ) : (
        <AIBetaOptIn
          handleEnableBeta={() =>
            handleEnableOrDisableBeta({
              callback: (optIn: boolean) => refetch(),
              organizationId: Number(project.organizationId),
              enable: true
            })
          }
        />
      )}
    </div>
  );
};
